"use strict";
// Copyright 2020-2022 SubQuery Pte Ltd authors & contributors
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.wrapApolloResult = void 0;
async function wrapApolloResult(_result) {
    const { error, data } = await _result;
    if (error) {
        throw error;
    }
    if (data) {
        return data;
    }
    throw new Error('unknown gql query error');
}
exports.wrapApolloResult = wrapApolloResult;
//# sourceMappingURL=apollo.js.map